export default __webpack_public_path__ + "static/media/date.c65320f8.svg";